// extracted by mini-css-extract-plugin
module.exports = {"news-banner-box":"b7","newsBannerBox":"b7","banner-wrap":"b8","bannerWrap":"b8","banner-title":"b9","bannerTitle":"b9","banner-img-box":"b-","bannerImgBox":"b-"};